import React from "react";
import Breadcrumbs from "../../common/breadcrumbs";
import { URL } from "../../../constants/URL";
import PromotionForm from "./PromotionForm";

const CreatePromotion = () => {
	return (
		<React.Fragment>
			<Breadcrumbs
				title="Promotions"
				data={[
					{ label: "Promotions", path: URL.promotions },
					{ label: "Add New Promotion" },
				]}
			/>
			<PromotionForm edit={true} />
		</React.Fragment>
	);
};

export default CreatePromotion;
